export {TNN_PERCENTAGE_DEFAULT} from './commonConfig';

const sponsorConfig = {
  oldSponsorInfo: 'Use Last Year’s Ad Spot',
  infoFromPartner:
    'I will provide the information needed to create the ad spot.',
  infoFromSponsor:
    'Please contact my sponsor to get the information needed for creating the ad spot',
  choosePreviousSponsor:
    'You can either choose a previous sponsor from the list (or)',
  addNewSponsor: 'Click "Add New Sponsor" to add a new sponsor',
  existingSponsorDialogTitle:
    'Choose an existing Sponsor Commercial (or) Add New',
  overrideSponsorConfirmTask:
    'Are you sure you want to skip Sponsor Approval and send this script directly to the Message Creator',
};

export default sponsorConfig;

export const musicConfig = {
  reAddTrackSuccess:
    'Selected tracks have been re-added to the library. Tracks will be available in the player after the next sync',
  songSetDeleteWarning: (songSetName: string, hasMusicSchedule: boolean) =>
    `The song set "${songSetName}" must be removed ${
      hasMusicSchedule
        ? 'from the following schedule(s)'
        : 'from the following event music mix(es) in Radio Mode'
    } before it can be deleted.`,
};

export const tnnSponsorConfig = {
  requestCompanySelection: 'Please select a company',
  noSchoolWarning: 'No school available for the selected company',
  noChildPartnerWarning: 'No child partners available',
};

export const excludePartnerConfirmMessage = {
  title: 'Are you sure you want to Exclude this task?',
  body: 'The associated partner will be added to the exclusion list and their data will no longer appear in Download Management.',
};

export const quickLaunchConfig = {
  addMessage: `Messaging is only available for Level 1 and Level 2 Partners. If you are interested in upgrading your account, please contact your Partner Success Manager, who can assist you.`,
};

export const alertMessageConfig = {
  fileNameWithoutZZZ: 'File name must not contain "zzz"',
  mp3_format_error: 'Please upload a valid mp3 file',
};

export const alertConfig = {
  mp3_format_error: 'Please upload a valid mp3 file',
  form_expired_invalid_token:
    'Form Expired, Since the coach already selected the song.',
  long_song_upload_limit:
    'You have already uploaded the maximum allowed number of songs longer than 90 seconds. Please contact your PSM for further assistance.',
};

export const songRequestRejectedMessage =
  'This song was rejected.  Please select a new song.';

export const confirmLockConfig = {
  confirmLockMessage:
    'This action will prevent any Player-side changes to this playlist from syncing to Voyager. Are you sure you want to continue?',
  confirmUnlockMessage:
    'This action will allow Player-side changes to this playlist to sync to Voyager. Are you sure you want to continue?',
  alertSuccessMessage:
    'Playlist locked successfully. Player-side changes will no longer sync to Voyager.',
  alertUnlockSuccessMessage:
    'Playlist unlocked successfully. Player-side changes will sync to Voyager',
};
export const tnnDemographicsConfig = {
  download_sample: 'Download Sample File',
  upload_queued_email_notification:
    'Configured PIF recipients will receive an email only when changes are detected.',
  gt_download_pop_up:
    'GameTime Partners: (Person/Men/Women) per events are required to calculate Total (Person/Men/Women)',
  non_gt_download_pop_up:
    'Non-GameTime Partners: Total (Person/Men/Women) are required to calculate (Person/Men/Women) per events',
};

export const tnnDistrictPartnerConfig = {
  childCoveredByDistrict: (districtName: string) =>
    `Already included through ${districtName}`,
  childrenRemoved: (districtName: string, childNames: string[]) =>
    `${childNames.join(', ')} ${
      childNames.length === 1 ? 'is' : 'are'
    } already covered by ${districtName} and ${
      childNames.length === 1 ? 'was' : 'were'
    } removed from the selection.`,
  districtCoverageHint: (childCount: number) =>
    `Includes ${childCount} child partner${childCount === 1 ? '' : 's'}`,
  districtChildCount: (childCount: number) =>
    `${childCount} child partner${childCount === 1 ? '' : 's'}`,
  inheritedChild: 'Inherited',
};

export const followUpMessageConfig = {
  followUpMessageTitle: 'Follow Up Details',
  followUpNotesUpdated: 'Follow-up notes updated successfully',
  followUpNotesUpdateFailed: 'Failed to update follow-up notes',
};
export const stationDeactivationConfig = {
  remainderSet: 'One or more stations have remainder set',
  remainderOverdue: 'One or more stations have overdue remainder',
};

export const fileVerificationConfig = {
  reset_message: 'Are you sure you want to reset the file:',
  reset_message_2: 'This will remove the uploaded file and reset the status.',
};

export const radioGenresConfig = {
  zeroPercentNotAllowed: 'Genre with 0% is not allowed',
  selectionMustBe100: 'Selection must be 100%',
  songSetNameTaken:
    'This Song Set name is already taken, please enter a unique name',
};
export const timedMessageConfig = {
  closureConflictWarning:
    'Another Closure Timed Message is already scheduled nearby. Proceeding will create multiple closure messages.',
};
export const hotkeyDuplicationConfig = {
  title: ' Replace Hot Key Assignment?',
  message: 'Proceeding will replace the existing track with the current one.',
};

export const trackAvailabilityConfig = {
  no_tracks: 'No tracks available.',
};

export const songSetConfig = {
  insufficient_tracks:
    'Insufficient songs in this Song Set (minimum 10 required).',
};
